// extracted by mini-css-extract-plugin
export default {"Footnote":"Footnote_Footnote__bJRSf"};